export default {
  noFilename: 'קובץ לא ידוע',
  labels: {
    date: 'תאריך:',
    user: 'משתמש:',
    fileType: 'סוג קובץ:',
    agentFullName: 'שם סוכן:',
    agentIdentifier: 'ת.ז.:',
    alternativeFundNumbers: 'מספר קרן אלטרנטיבית:',
    clientNumbers: 'מספר תיק:',
    agreementNumbers: 'מספר הסכם:',
  },
  fileTypes: {
    monthly: 'נפרעים',
    annualAccumulation: 'היקף',
  },
  actions: {
    editAgent: 'ערוך סוכן',
    reassignAgent: 'שייך לסוכן קיים',
    retry: 'עבד מחדש',
    retryAgain: 'נסה שוב',
    closeEvent: 'סגור אירוע',
  },
  fields: {
    companyLabel: 'חברה',
    companyPlaceholder: 'בחר חברה...',
    yearLabel: 'שנה',
    monthLabel: 'חודש',
    monthPlaceholder: 'בחר חודש...',
    referenceYearLabel: 'שנת ייחוס',
    ambiguousLabel: 'בחר מבין ההצעות',
    selectPlaceholder: 'בחר...',
    ruleLabel: 'בחר חוק',
    sheetExpected: 'ציפינו לגיליון {1}. הגיליונות שנמצאו בקובץ: {2}',
    fileExpected: 'החוק מצפה לקובץ {1}. הקבצים שהתקבלו: {2}. יש להעלות את כל קבצי החוק.',
    sheetPickLabel: 'איזה מהגיליונות הוא {1}?',
  },
  notification: {
    retrySuccess: { title: 'הצלחה', message: 'הקובץ נשלח לעיבוד מחדש' },
    retryError: { title: 'שגיאה', message: 'לא ניתן לעבד את הקובץ, נסה שנית' },
    closeError: { title: 'שגיאה', message: 'לא ניתן לסגור את האירוע' },
  },
};
